<template>
    <v-dialog persistent v-model="dialog" width=70%>
        <v-card class="px-2">
            <v-container v-show="showChange">
                <!-- header info -->
                <v-row class="pa-4 pb-2" v-if="change_key === ''">  <!-- New change -->
                    <h3>New change</h3>
                    <v-spacer></v-spacer>
                    <span class="ml-6 mt-0" v-if="huis_encrid !== ''">
                        <v-btn 
                            color="primary" 
                            small 
                            :disabled="huis_encrid === ''"
                            v-on:click="selectHuovs">
                            Select bookings
                        </v-btn>
					</span>
                </v-row>
                <v-row class="pa-4 pb-2" v-else>  <!-- Existing change -->
					<span><h3>Update change {{ change_key }}</h3></span>
					<v-spacer></v-spacer>
                    <!-- Edit existing change for all bookings, do not change selection (add or remove bookings)  -->
                    <!-- 
                    <span class="ml-6 mt-0" v-if="huis_encrid !== ''">
                        <v-btn 
                            color="primary" 
                            small 
                            :disabled="huis_encrid === ''"
                            v-on:click="selectHuovs">
                            Select bookings
                        </v-btn>
					</span>
                     -->
					<span class="ml-6 mt-0">
						<attm_button :attachments="attachments" :encrid="howz_encrid" entity="howz" :entitykey="change_key" @updateData="updateAttachments"/>
					</span>
<!-- 
                    <span class="ml-6 mt-1">
						<mail_button :mails="mails" :encrid="howz_encrid" @showDialog="showMailDialog"/>
					</span>
-->
                </v-row>
                <v-row dense class="px-2">
                    <span style="font-size: small;">
                        Duration <b>{{ howz_normal_days }}</b> days, business days <b>{{ howz_business_days }}</b>
                    </span>
                </v-row>

                <v-row class="pl-1 px-0 mx-0"> 
                    {{ description }}<span v-if="huis_encrid !== ''">&nbsp;({{ selected_message }})</span>
                </v-row>
                <v-row><v-divider></v-divider></v-row>

                <!-- Dropdowns: initiatedby & assigned to -->
                <selections :howz_initiatief="howz_initiatief" :howz_gebr="howz_gebr" :selected_wzct="selected_wzct" @updateField="updateField"/>
                <v-row dense><v-col cols="12"><v-divider></v-divider></v-col></v-row>

                <!-- Description for change -->
                <v-row dense>
                    <v-col cols="12">
                        <v-textarea v-model="howz_wijziging_oms" :rows="2" required label="Change event description" v-bind:rules="descriptionRules"> {{ howz_wijziging_oms }}</v-textarea>
                    </v-col>
                </v-row>
                <v-row dense><v-col cols="12"><v-divider></v-divider></v-col></v-row>

                <!-- Change detials: redenen, meerkosten & alternatieven -->
                <v-row dense>
                    <v-col cols="8">
                        <v-textarea v-model="howz_reden" :rows="2" label="Reason for change">{{ howz_reden }}</v-textarea>
                    </v-col>
                    <v-col cols="4" class="pt-4">
                        <span class="link_style">Links for reason</span>
                        <howz_links :links="howz_reden_urls" @updateData="updateField"/>
                    </v-col>
                </v-row>
                <v-row dense><v-col cols="12"><v-divider></v-divider></v-col></v-row>
                <v-row dense class="pt-2"><v-col cols="12"><v-divider></v-divider></v-col></v-row>

                <!-- Change: Internal memo veld -->
                <v-row>
                    <v-col cols="12">
                        <v-textarea v-model="howz_memo" :rows="8" label="Internal memo">{{ howz_memo }}</v-textarea>
                    </v-col>
                </v-row>
                <v-row><v-divider></v-divider></v-row>
                <v-row dense>
                    <v-col cols="12">
                        <v-card-actions>
                            <v-spacer />
                            <v-btn 
                                color="primary" 
                                small 
                                :disabled="howz_initiatief === '' || selected_wzct.length === 0 || selected_huovs.length === 0 || howz_wijziging_oms === ''"
                                v-on:click="addUpdHowz()">Save</v-btn>
                            <v-btn color="primary" small v-on:click="closeDialog">Close</v-btn>
                        </v-card-actions>
                    </v-col>
                </v-row>
            </v-container>
            <v-container v-show="showSelection">
                <select_huovs ref="select_huovs" :huis_encrid="huis_encrid" :data="huis_huovs" :selected_data="selected_huovs" :selected_message="selected_message"  @updateData="updateData" @updateField="updateField"/>
            </v-container>
            <v-container v-show="showSelectHowz">
                <select_howz ref="select_howz" :huis_encrid="huis_encrid" :data="huis_howzs" @updateData="updateData" @updateField="updateField" @open_dialog="open_dialog" @close_dialog="closeDialog"/>
            </v-container>
        </v-card>
        <rmHowz ref="rmHowz" @updateData="updateData" @updateField="updateField"/>
    </v-dialog>
</template>
  
<script>
    import select_huovs from '@/components/huov/howz/selectHuovs.vue';
    import select_howz from '@/components/huov/howz/selectHowz.vue';
    import selections from '@/components/huov/howz/ui/screen_selections.vue';
    import howz_links from '@/components/huov/ui/hokl_hosm_links.vue';
    import rmHowz from "@/components/huov/howz/rmHowz.vue";
    import attm_button from '@/components/huov/ui/attm_button.vue';

    export default {
        components: {
            howz_links,
            selections,
            attm_button,
            rmHowz,
            select_huovs,
            select_howz,
        },
        props: {
            huov_encrid: {
                type: String,
                default: '',
                required: false
            },
            huis_encrid: {
                type: String,
                default: '',
                required: false
            },
        },
        data() {
            return {
                dialog: false,
                showChange: false,
                showSelection: false,
                showSelectHowz: false,
                change_key: '',
                description: '',
                selected_message: '',
                view: '',

                howz_encrid: '',
            
                howz_gebr: '',
                howz_wijziging_oms: '',
                howz_reden: '',
                howz_reden_urls: [],
                // howz_meerkosten: '',
                // howz_meerkosten_urls: [],
                // howz_alternatief: '',
                // howz_alternatief_urls: [],
                howz_memo: '',
                howz_initiatief: '',
                howz_business_days: 0,
                howz_normal_days: 0,
                selected_wzct: [],

                selected_huovs: [],
                huis_huovs: [],
                huis_howzs: [],

                attachments: 0,

                descriptionRules: [v => !!v || "A description / value is required"]
            }
        },
        watch:{
            selected_huovs() {            
                this.selected_message = this.makeSelectText();               
            },
        }, 
        methods: {
            new_dialog() {
                // Reset component visability
                this.showChange = false;
                this.showSelection = false;
                this.showSelectHowz = false;

                // Reset component data
                this.howz_encrid = '';
                this.change_key = '';
                this.description = '';
                this.selected_message = '';
                this.view = '',
    
                this.howz_gebr = '';
                this.howz_wijziging_oms = '';
                this.howz_reden = '';
                this.howz_reden_urls = [];
                // this.howz_meerkosten = '';
                // this.howz_meerkosten_urls = [];
                // this.howz_alternatief = '';
                // this.howz_alternatief_urls = [];
                this.howz_memo = '';
                this.howz_initiatief = ''; 
                this.howz_business_days = 0;
                this.howz_normal_days = 0;
                this.selected_wzct = [];

                this.selected_huovs = [];
                this.huis_huovs = [];
                this.huis_howzs = [];

                this.attachments = 0; 
            },
            open_dialog(view, howz_encrid, change_key, description) {
                // Reset component
                this.new_dialog();

                this.howz_encrid = howz_encrid;
                this.change_key = change_key;
                this.description = description;

                this.view = view;

                console.log(change_key, view)

                //console.log(view);

                switch(view) {
                    case 'multiple': 
                        this.getHuovs();
                        break;
                    case 'select':
                        this.getHuisHowz(true);
                        break;
                    case 'close_select': 
                        this.closeDialog();
                        break;
                    case 'edit_multiple':
                        this.getSingleHowz();
                        break;
                    case 'edit_single': 
                        this.getSingleHowz();
                        break;
                    case 'add_single': 
                        // Select only the current huov
                        this.getHuovs();
                        break;
                    case 'delete_multiple':
                        this.$refs.rmHowz.openAll(howz_encrid, change_key);
                        break;
                }
            },
            getSingleHowz() {
                this.$axios.post("ares/json/ares/huov/howz/getHowz.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHowz"
                    },
                    getHowz: {
                        huov_encrid: this.huov_encrid,
                        howz_encrid: this.howz_encrid,
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        this.dialog = false; // do not show dialog
                    } else {
                        // getHowz returns an array, with one howz (there is only one).
                        let howz = res.data.getHowz.howz[0];

                        this.howz_gebr = howz.howz_gebr;
                        this.howz_wijziging_oms = howz.howz_wijziging_oms;
                        this.howz_reden = howz.howz_reden;
                        this.howz_reden_urls = howz.howz_reden_urls;
                        // this.howz_meerkosten = howz.howz_meerkosten;
                        // this.howz_meerkosten_urls = howz.howz_meerkosten_urls;
                        // this.howz_alternatief = howz.howz_alternatief;
                        // this.howz_alternatief_urls = howz.howz_alternatief_urls;
                        this.howz_memo = howz.howz_memo;
                        this.howz_initiatief = howz.howz_initiatief;
                        this.howz_business_days = howz.howz_business_days;
                        this.howz_normal_days = howz.howz_normal_days;
                        this.selected_wzct = howz.selected_wzct;

                        this.attachments = howz.attachments;

                        this.change_key = howz.change_key; 

                        this.getHuovs();
                    }
                });
            },
            getHuovs() {
                this.$axios.post("ares/json/ares/huov/howz/getHuovs.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHuovs"
                    },
                    getHuovs: {
                        huis_encrid: this.huis_encrid,
                        huov_encrid: this.huov_encrid,
                        howz_encrid: this.howz_encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        this.dialog = false;
                    } else {
                        this.huis_huovs = res.data.getHuovs;
                        this.selected_huovs = [];
                        for (let i = 0; i < this.huis_huovs.length; i++) {
                            if (this.huis_huovs[i].huov_selected) {
                                this.selected_huovs.push(this.huis_huovs[i]);  
                            }           
                        }
                        this.selected_message = this.makeSelectText();
                        this.showChange = true;
                        this.dialog = true;
                    }
                });
            },
            getHuisHowz(show) {
                this.$axios.post("ares/json/ares/huov/howz/getHuisHowz.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHuisHowz"
                    },
                    getHuisHowz: {
                        huis_encrid: this.huis_encrid,
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        this.dialog = false;
                    } else {
                        this.huis_howzs = res.data.getHuisHowz;
                        if (show) {
                            this.showSelectHowz = true;
                            this.dialog = true;
                        }
                    }
                });
            },
            addUpdHowz() {
                let huov_encrids = [];
                for (let i = 0; i < this.selected_huovs.length; i++) {
                    huov_encrids.push(this.selected_huovs[i].huov_encrid);         
                }
                let add_upd_data = {
                    huis_encrid: this.huis_encrid,
                    huov_encrid: this.huov_encrid,
                    howz_encrid: this.howz_encrid,

                    view: this.view,

                    howz_gebr: this.howz_gebr,
                    howz_wijziging_oms: this.howz_wijziging_oms,
                    howz_reden: this.howz_reden,
                    howz_reden_urls: this.howz_reden_urls,
                    // howz_meerkosten: this.howz_meerkosten,
                    // howz_meerkosten_urls: this.howz_meerkosten_urls,
                    // howz_alternatief: this.howz_alternatief,
                    // howz_alternatief_urls: this.howz_alternatief_urls,
                    howz_memo: this.howz_memo,
                    howz_caused_by: this.howz_initiatief,

                    selected_wzct: this.selected_wzct,
                    huov_encrids: huov_encrids,
                }     
                // console.log(add_upd_data);          
                if (this.howz_encrid === "") {
                    this.$axios.post("ares/json/ares/huov/howz/addHowz.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "addHowz"
                        },
                        addHowz: add_upd_data
                    }).then(res => {
                        if (res.data.error) {
                            console.log(res.data.error);
                            // laten we hopen dat dit nooit gebeurt, we zetten de gebruiker vast in dit dialog met een melding of iets
                        } else {
                            this.closeDialog();                       
                        }
                    }).finally();
                } else {
                    this.$axios.post("ares/json/ares/huov/howz/updHowz.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "updHowz"
                        },
                        updHowz: add_upd_data
                    }).then(res => {
                        if (res.data.error) {
                            console.log(res.data.error);
                            // laten we hopen dat dit nooit gebeurt, we zetten de gebruiker vast in dit dialog met een melding of iets
                        } else {
                            this.closeDialog();                       
                        }
                    }).finally();
                }
            },
            selectHuovs() {
                console.log("Huovs ", this.huis_huovs);
                console.log("selected ", this.selected_huovs);
                this.showChange = false;
                this.showSelectHowz = false;
                this.showSelection = true;
            },
            closeDialog() {
                // console.log('close dialog');
                console.log('close dialog', this);
                this.$emit("updateData", "refresh");
                this.showChange = false;
                this.showSelectHowz = false;
                this.showSelection = false;
                this.dialog = false;
            },
            // showMailDialog(encrid){
            //     this.$refs.mailDialog.open(encrid);
            // },
            updateAttachments(){
                this.getSingleHowz();
            },
            updateData(data){
                console.log("update data add_upd_howz", data);
                if (data === 'update_howz') {
                    this.getHuisHowz(false);
                }
                this.selected_message = this.makeSelectText();
            },
            updateField(data){
                console.log("update field add_upd_howz", data);
                this[data.field] = data.value;
                //console.log(this);
                this.selected_message = this.makeSelectText();
            },
            makeSelectText() {
                if (this.selected_huovs.length === 0) {
                    return "no bookings selected";
                }
                if (this.selected_huovs.length === 1) {
                    return "1 booking selected";
                }
                return this.selected_huovs.length + " bookings selected";
            },			
        }
    }
</script>
  
<style scoped>
	.flex{
		display: flex;
		flex-direction: row;
		align-items: center;
	}
    .ul_style {
        list-style-type: none;
        /* Remove bullets */
        padding: 0;
        /* Remove padding */
        margin: 0;
        /* Remove margins */
        height: 315px;
        overflow-y: auto;
    }
    .link_style {
        color: grey;
    }
</style>